import './style.css'
const Footer = () => {
    return (
        <div className="footerComponent">
            <footer>
            <p>Rio de Janeiro, 2024 - Designed By Vitória Chaves</p>
        </footer>
        </div>
    )
}

export default Footer